// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function cashElSalvadorianOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'cash',
    payment_type_code: 'puntoxpress',
  };
}
